// extracted by mini-css-extract-plugin
export default {"title":"Team_title__Pr6m0","titleItalic":"Team_titleItalic__vim5Q","sliderButtonContainer":"Team_sliderButtonContainer__n8i5k","sliderImage":"Team_sliderImage__fO4vU"};